import React from "react"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons
import Update from "@material-ui/icons/Update"
import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn"
import Feedback from "@material-ui/icons/Feedback"
// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import InfoArea from "components/InfoArea/InfoArea.jsx"

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx"
import YouTube from "react-youtube"
// https://youtu.be/B5pgwhf6v80
// https://www.youtube.com/watch?v=B5pgwhf6v80&feature=youtu.be

const opts = {
  height: '390',
  width: '100%',
  playerVars: {
    // https://developers.google.com/youtube/player_parameters
    autoplay: 0,
  },
}
class ProductSection extends React.Component {
  videoOnReady(event) {
    // access to player in all event handlers via event.target
    event.target.pauseVideo()
  }
  render() {
    const { classes } = this.props
    return (
      <div>
        <div className={classes.section}>
          <GridContainer justify="center">
            <GridItem xs={11} sm={12} md={10}>
              <h2 className={classes.title}>What is Privasee App?</h2>
              <h3 className={classes.description}>
                We are building the air traffic control of sensitive data; we help companies
                understand the data they have, where their data comes from, where it goes to, what
                they do with it and what its risks are.
                <br/><br/>
                Companies spend thousands of pounds per year to prevent data breaches and comply
                with privacy regulations - we make the process instant for less than the cost of a
                monthly Travel Card. Our platform finds sensitive information from existing
                databases, keeps track of incoming data, and then monitors its access, helping
                companies understand and reduce risk.
              </h3>
            </GridItem>
          </GridContainer>
          <div>
            <GridContainer style={{ justifyContent: "center" }}>
              <GridItem xs={11} sm={12} md={4}>
                <InfoArea
                  title="Automatic Data Gathering"
                  description="
                  To stay on top of their data companies are forced to query their employees, taking them up to five hours to understand what a single element is used for. With our data discovery tools you will find all of your information in minutes.
                  "
                  icon={Update}
                  iconColor="privasee"
                  vertical
                />
              </GridItem>
              <GridItem xs={11} sm={12} md={4}>
                <InfoArea
                  title="Always On Track"
                  description="
                  Be able to see and understand how data moves through your organisation. Where your data is, where it was collected from, how many people it involves, what is being used for - all accessible through our online portal.
                  "
                  icon={AssignmentTurnedIn}
                  iconColor="privasee"
                  vertical
                />
              </GridItem>
              <GridItem xs={11} sm={12} md={4}>
                <InfoArea
                  title="Data Governance Made Easy"
                  description="
                  You will be able to see and manage potential threats, warning you of security and legal risks before they occur, and guiding you through data breaches or regulatory inquiries.
                  "
                  icon={Feedback}
                  iconColor="privasee"
                  vertical
                />
              </GridItem>
            </GridContainer>
            <GridContainer justify="center" style={{marginTop: 70}}>
              <GridItem xs={12} sm={12} md={10}>
                <h2 className={classes.title}>Want to know more?</h2>
              </GridItem>
              <GridItem xs={11} sm={12} md={8}>
                <YouTube
                  videoId="j-ND5rAt4gc"
                  opts={opts}
                  onReady={this.videoOnReady}
                />
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(productStyle)(ProductSection)
